export function ErrorPage(props) {
  return <h1>Error</h1>;
}
